/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Tooltip, Modal, ModalBody, ModalHeader, ModalFooter, Button, FormGroup, Label, Col, Input, InputGroup, InputGroupAddon, Form, Progress, Table } from 'reactstrap';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';
import ProviderService from '../../services/ProviderService';
import GeneralService from '../../services/GeneralService';

// local imports
import ProviderNavbar from './ProviderNavbar';
import Message from '../general/Message';
import Loading from '../../assets/UW_Horizontal_Logo_Full.png';


const ProviderSubscriptionMakePayment = props => {

    // states
    const [disablePaymentBtn, setDisablePaymentBtn] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [totalAmount, setTotalAmount] = useState(0);
    const [GST, setGST] = useState({ percent: 0, amount: 0 });
    const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState({});
    const [updateDetails, setUpdateDetails] = useState({ isUpdate: false });
    const [paymentDetails, setPaymentDetails] = useState({});

    // contexts
    const { theme, colors } = useContext(ThemeContext);
    const { user } = useContext(AuthContext);

    // utility functions
    const loadScript = (src) => {
        try {
            return new Promise((resolve) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = () => {
                    resolve(true);
                }
                script.onerror = () => {
                    resolve(false);
                }
                document.body.appendChild(script);
            })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at MakePayment loadScript', err.stack);
        }
    }

    // useEffects
    useEffect(() => {
        if (updateDetails.isUpdate) {
            // console.log(updateDetails);
            if (updateDetails.amount.remainingDays) {
                setTotalAmount((updateDetails.amount.newAmount - updateDetails.amount.balanceAmount) / 100);
            }
            if (updateDetails.sessionBookingLimit.remaining < 0 || updateDetails.clientLimit.remaining < 0) {
                setDisablePaymentBtn(true);
            }
        }
    }, [updateDetails])

    useEffect(() => {
        try {
            if (props.location.state) {
                // console.log("states", props.location.state)
                // const isFreePlan = props.location.state.oldPlan.providerSubscriptionPlan.na/me === "Free";
                setSelectedSubscriptionPlan(props.location.state.selectedSubscriptionPlan);
                if (props.location.state.isUpdate && props.location.state.oldPlan.providerSubscriptionPlan.name !== "Free") {
                // if (props.location.state.isUpdate) {
                    const currentCycleTotalDays = props.location.state.oldPlan.currentCycleTotalDays;
                    const remainingDays = currentCycleTotalDays - props.location.state.oldPlan.currentCycleDaysGone;
                    const prevPerDayAmount = props.location.state.oldPlan.providerSubscriptionPlan.amount / currentCycleTotalDays;
                    const nextPerDayAmount = props.location.state.selectedSubscriptionPlan.amount / currentCycleTotalDays;
                    const activeProviderSubscriptionIndex = props.location.state.oldPlan.subscriptionCycle.length - 1;
                    // console.log('currentCycleTotalDays', currentCycleTotalDays, 'remainingDays', remainingDays, 'prevPerDayAmount', prevPerDayAmount, 'nextPerDayAmount', nextPerDayAmount, 'activeProviderSubscriptionIndex',activeProviderSubscriptionIndex)
                    setUpdateDetails({
                        clientLimit: {
                            old: props.location.state.oldPlan.subscriptionCycle[activeProviderSubscriptionIndex].serviceDetails.clientCount,
                            new: props.location.state.selectedSubscriptionPlan.serviceDetails.clientLimit,
                            remaining: props.location.state.selectedSubscriptionPlan.serviceDetails.clientLimit - props.location.state.oldPlan.subscriptionCycle[activeProviderSubscriptionIndex].serviceDetails.clientCount
                        },
                        sessionBookingLimit: {
                            old: props.location.state.oldPlan.subscriptionCycle[activeProviderSubscriptionIndex].serviceDetails.sessionBookingCount,
                            new: props.location.state.selectedSubscriptionPlan.serviceDetails.sessionBookingLimit,
                            remaining: props.location.state.selectedSubscriptionPlan.serviceDetails.sessionBookingLimit - props.location.state.oldPlan.subscriptionCycle[activeProviderSubscriptionIndex].serviceDetails.sessionBookingCount
                        },
                        amount: {
                            old: props.location.state.oldPlan.providerSubscriptionPlan.amount,
                            new: props.location.state.selectedSubscriptionPlan.amount,
                            remaining: props.location.state.selectedSubscriptionPlan.amount - props.location.state.oldPlan.providerSubscriptionPlan.amount,
                            remainingDays: remainingDays,
                            oldPerDayAmount: prevPerDayAmount,
                            newPerDayAmount: nextPerDayAmount,
                            balanceAmount: prevPerDayAmount * remainingDays,
                            newAmount: nextPerDayAmount * remainingDays
                        },
                        razorpaySubscriptionId: props.location.state.oldPlan.razorpaySubscriptionId,
                        isUpdate: true,
                        currentCycleStartDate: props.location.state.oldPlan.currentCycleStartDate,
                        currentCycleDaysGone: props.location.state.oldPlan.currentCycleDaysGone,
                        currentCycleTotalDays: currentCycleTotalDays
                    })
                } else {
                    setTotalAmount(props.location.state.selectedSubscriptionPlan.amount / 100);
                }
                setDisablePaymentBtn(false)
                setIsLoading(false);
                // console.log(props.location.stateselectedSubscriptionPlan)
            } else {
                // console.log('props', props.history);
                props.history.replace('mysubscription');
            }
        }
        catch (err) {
            console.log(err);
        }
    }, [props.location.state]);


    // handle functions
    const handlePayment = e => {
        if (selectedSubscriptionPlan._id) {
            setDisablePaymentBtn(true);
            setIsLoading(true);
            try {
                if (selectedSubscriptionPlan.name === "Free" && selectedSubscriptionPlan.razorpaySubscriptionPlanId === "") {
                    postProviderSubscription(selectedSubscriptionPlan._id, "");
                } else {
                    ProviderService.postRazorpayProviderSubscription(selectedSubscriptionPlan.razorpaySubscriptionPlanId, {
                        providerSubscriptionPlanId: selectedSubscriptionPlan._id,
                        providerEmail: user.email,
                        providerName: user.username,
                        subscriptionName: 'provider-subscription'
                    }).then(data => {
                        try {
                            displayRazorpayInterface(data.response.id, 'Payment against creating Provider Subsription')
                        } catch (err) {
                            setDisablePaymentBtn(false);
                            console.log(err);
                        }
                    });
                }
            }
            catch (err) {
                setDisablePaymentBtn(false);
                console.log(err);
            }
        }
    }

    const handlePlanUpdate = e => {
        if (selectedSubscriptionPlan._id) {
            setDisablePaymentBtn(true);
            setIsLoading(true);
            try {
                ProviderService.updateProviderSubscription(updateDetails.razorpaySubscriptionId, selectedSubscriptionPlan).then(data => {
                    // console.log("data", data);
                    setIsLoading(false);
                    setDisablePaymentBtn(false);
                    props.history.push('mysubscription');
                }).catch(err => {
                    console.log("err3", err);
                    setDisablePaymentBtn(false);
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                });
            } catch (err) {
                console.log("err2", err);
                setDisablePaymentBtn(false);
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                // GeneralService.logError('at BookSession handleSubmit', err.stack);
            }
        }
    }

    const displayRazorpayInterface = async (razorpaySubscriptionId, description) => {
        try {
            const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

            if (!res) {
                console.log('Razorpay SDK failed to load');
                return;
            }

            const options = {
                key: "rzp_test_S5VDzRjlueD699",
                subscription_id: razorpaySubscriptionId,
                name: user.email,
                description: description,
                handler: function (response) {
                    postProviderSubscription(selectedSubscriptionPlan._id, response.razorpay_subscription_id);
                },
                modal: {
                    ondismiss: function () {
                        setIsLoading(false);
                        setDisablePaymentBtn(false);
                        // console.log("Checkout form closed");
                    }
                },
                prefill: {
                    name: user.username,
                    email: user.email
                }
            }
            const paymentObject = new window.Razorpay(options)
            paymentObject.open();
        } catch (err) {
            setIsLoading(false);
            setDisablePaymentBtn(false);
        }
    }

    const postProviderSubscription = (selectedSubscriptionPlanId, razorpaySubscriptionId) => {
        ProviderService.postProviderSubscription(selectedSubscriptionPlanId, razorpaySubscriptionId).then(data => {
            // console.log("data", data);
            setIsLoading(false);
            setDisablePaymentBtn(false);
            props.history.push('/counsellor/subscription');
        });
    }

    // function's return
    return (
        <div>
            <ProviderNavbar history={props.history} />
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    <div className='p-3'>
                        <div>
                            <h1 style={theme.headingBoldPrimaryColor}>Make Payment</h1>
                            <hr style={{ borderWidth: "2px" }} />
                        </div>
                        <div className='p-3'>
                            <h2 style={theme.subHeadingSemibold}>Confirm Subscription Details</h2>
                            <hr />


                            <Table borderless className="mt-4" id="provider-subscription-details">
                                <tbody>
                                    <tr>
                                        <td style={{ minWidth: '10rem', width: '18rem' }}>
                                            <span style={theme.h3HeadingSemibold}>Subscription Plan</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>{selectedSubscriptionPlan.name}</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span style={theme.h3HeadingSemibold}>Session Bookings</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>{updateDetails.isUpdate ? `${updateDetails.sessionBookingLimit.new} total - ${updateDetails.sessionBookingLimit.old} used = ${updateDetails.sessionBookingLimit.remaining} remaining` : selectedSubscriptionPlan.serviceDetails.sessionBookingLimit}</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span style={theme.h3HeadingSemibold}>Clients</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>{updateDetails.isUpdate ? `${updateDetails.clientLimit.new} total - ${updateDetails.clientLimit.old} used = ${updateDetails.clientLimit.remaining} remaining` : selectedSubscriptionPlan.serviceDetails.clientLimit}</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span style={theme.h3HeadingSemibold}>Call Sessions</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>
                                                <i className={`fas fa-${selectedSubscriptionPlan.serviceDetails.modeOfServices.call ? 'check' : 'times danger_text_color'}`}></i>
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span style={theme.h3HeadingSemibold}>Chat Sessions</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>
                                                <i className={`fas fa-${selectedSubscriptionPlan.serviceDetails.modeOfServices.chat ? 'check' : 'times danger_text_color'}`}></i>
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span style={theme.h3HeadingSemibold}>Video Sessions</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>
                                                <i className={`fas fa-${selectedSubscriptionPlan.serviceDetails.modeOfServices.video ? 'check' : 'times danger_text_color'}`}></i>
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span style={theme.h3HeadingSemibold}>In Person Sessions</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>
                                                <i className={`fas fa-${selectedSubscriptionPlan.serviceDetails.modeOfServices.inPerson ? 'check' : 'times danger_text_color'}`}></i>
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span style={theme.h3HeadingSemibold}>Create Client Subscription Plans</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>
                                                <i className={`fas fa-${selectedSubscriptionPlan.serviceDetails.createClientSubscriptionPlans ? 'check' : 'times danger_text_color'}`}></i>
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span style={theme.h3HeadingSemibold}>Start Date</span>
                                        </td>
                                        <td>
                                            <span style={theme.paragraphMDSM}>{moment().format('MMM DD, dddd')}</span>
                                        </td>
                                    </tr>

                                    {
                                        updateDetails.isUpdate ?
                                            <tr>
                                                <td>
                                                    <span style={theme.h3HeadingSemibold}>Days Passed</span>
                                                </td>
                                                <td className="d-flex">
                                                    <Progress className="successProgress my-auto mr-2" value={(100 * updateDetails.currentCycleDaysGone) / updateDetails.currentCycleTotalDays} /><span style={theme.paragraphMDSM}>{`${updateDetails.currentCycleDaysGone}/${updateDetails.currentCycleTotalDays}`}</span>
                                                </td>
                                            </tr>
                                            : null
                                    }

                                </tbody>
                            </Table>

                        </div>
                        <div className='mt-5 p-3'>
                            <h2 style={theme.subHeadingSemibold}>Payment</h2>
                            <hr />
                            <Table borderless className="mt-4" id="finalCharges">
                                {
                                    updateDetails.isUpdate ?
                                        <tbody>
                                            <tr>
                                                <td style={{ minWidth: '12.5rem', width: '12.5rem' }}>
                                                    <span style={theme.h3HeadingSemibold}>Subscription Charges</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹{Number(updateDetails.amount.new / 100).toFixed(2)}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ minWidth: '12.5rem', width: '12.5rem' }}>
                                                    <span style={theme.h3HeadingSemibold}>Current Balance</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹{Number(updateDetails.amount.balanceAmount / 100).toFixed(2)}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={theme.h3HeadingSemibold}>GST({GST.percent}%)</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹{GST.amount}</span>
                                                </td>
                                            </tr>
                                            {
                                                totalAmount < 0 ?
                                                    <tr>
                                                        <td>
                                                            <span style={theme.h3HeadingSemibold}>Total Refund</span>
                                                        </td>
                                                        <td>
                                                            <span style={theme.paragraphMDSM}>₹{Math.abs(totalAmount + GST.amount).toFixed(2)}</span>
                                                        </td>
                                                    </tr>
                                                    :
                                                    <tr>
                                                        <td>
                                                            <span style={theme.h3HeadingSemibold}>Total Amount Due</span>
                                                        </td>
                                                        <td>
                                                            <span style={theme.paragraphMDSM}>₹{Number(totalAmount + GST.amount).toFixed(2)}</span>
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td style={{ minWidth: '12.5rem', width: '12.5rem' }}>
                                                    <span style={theme.h3HeadingSemibold}>Subscription Charges</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹{Number(selectedSubscriptionPlan.amount / 100).toFixed(2)}</span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <span style={theme.h3HeadingSemibold}>GST({GST.percent}%)</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹{GST.amount}</span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <span style={theme.h3HeadingSemibold}>Total Amount Due</span>
                                                </td>
                                                <td>
                                                    <span style={theme.paragraphMDSM}>₹{Number(totalAmount + GST.amount).toFixed(2)}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </Table>
                        </div>
                        <button className="btn my-2" style={theme.button} disabled={disablePaymentBtn} onClick={updateDetails.isUpdate ? handlePlanUpdate : handlePayment}>
                            {
                                totalAmount < 0 ?
                                    `Request refund ₹${Math.abs(totalAmount + GST.amount).toFixed(2)} and Update`
                                    : `Pay ₹${Number(totalAmount + GST.amount).toFixed(2)} and Subscribe`
                            }
                        </button>
                    </div>
            }
        </div>
    )
}

export default ProviderSubscriptionMakePayment;